import { trimValue } from '../../common/helper';
import FormattedDateTime from '../../common/datetime/FormattedDateTime';
import React, { Fragment, useState } from 'react';
import Table from '../../table/Table';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../store/store';
import { Button, Dropdown } from 'react-bootstrap';
import { DropdownWrapper } from '../../common/DropdownWrapper';
import { faSnooze } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { snoozeInternalApi } from '../../apis';
import { fetchPerson } from '../amlActions';
import { showFeedback } from '../../feedback/feedbackReducer';
import SnoozeModal from '../../common/snooze/SnoozeModal';
import accounting from 'accounting';
import { InternalApiSnoozeConfig } from '../../api-internal';
import { showConfirmationModal } from '../../confirmation-modal/confirmationModalReducer';
import { nonBreakingSpace } from '../../schema/helper';

interface Props {
  personId: string;
}

export const SnoozedScenarios = ({ personId }: Props) => {
  const dispatch = useDispatch();
  const [showSnoozeModal, setShowSnoozeModal] = useState(false);
  const person = useSelector((state: AppState) => state.aml.person);
  const snoozedScenarios = person?.scenarioSnoozeConfigurations ?? new Array<InternalApiSnoozeConfig>();

  // All snoozed scenarios are already fetched with person.
  const totalPages = 1;
  const currentPage = 0;
  const pageSize = 1;

  const endSnooze = async (snooze: InternalApiSnoozeConfig) => {
    dispatch(
      showConfirmationModal({
        title: 'Are you sure?',
        description: 'You are going to remove scenario snooze configuration',
        confirmationText: 'Yes',
        cancelText: 'No',
        onConfirm: async () => {
          await snoozeInternalApi.deleteSnoozeConfiguration({
            personId: personId,
            internalApiSnoozeConfig: {
              scenarioHandle: snooze.scenarioHandle,
              note: snooze.note,
              createdBy: snooze.createdBy,
            },
          });
          await dispatch(fetchPerson(personId));
          await dispatch(
            showFeedback({
              message: 'Scenario snooze ended successfully',
              success: true,
            })
          );
        },
      })
    );
  };

  return (
    <>
      {showSnoozeModal && (
        <SnoozeModal
          personId={personId}
          modalClosedCallback={() => {
            setShowSnoozeModal(false);
          }}
        />
      )}
      <Table
        title={
          <>
            {'Snoozed scenarios '}
            <span className='sanction-amount-info'>({snoozedScenarios.length})</span>
          </>
        }
        total={totalPages}
        page={currentPage}
        size={pageSize}
        items={snoozedScenarios}
        fetchPage={() => null}
        attributes={[
          { key: 'Scenario', sortable: false },
          { key: 'Snoozed by', sortable: false },
          { key: 'End date', sortable: false },
          { key: 'Limit', sortable: false },
          { key: 'Actions', sortable: false },
        ]}
        actions={() => {
          return (
            <div>
              <Button
                variant='secondary'
                size='sm'
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  setShowSnoozeModal(true);
                }}
              >
                <FontAwesomeIcon className='fe me-2' icon={faSnooze} />
                Snooze
              </Button>
            </div>
          );
        }}
        expandable={true}
        expandedByDefault={false}
        emptyMessage='No scenarios snoozed'
        hidePageInfo={true}
        responsive={false}
        body={(alerts) =>
          alerts.map((snooze: InternalApiSnoozeConfig) => (
            <Fragment key={snooze.id}>
              <tr>
                <td>{trimValue(snooze.scenarioReason!, 50, true)}</td>
                <td>{snooze.createdBy.name ?? snooze.createdBy.email}</td>
                <td>
                  <FormattedDateTime date={snooze.endTime} />
                </td>
                <td>
                  {snooze.totalAmount ? accounting.formatNumber(Number(snooze.totalAmount), 0, nonBreakingSpace) : '-'}
                </td>
                <td>
                  <DropdownWrapper align='end'>
                    <Dropdown.Toggle as={Button} size='sm' className='btn-white' id='actions-dropdown'>
                      •••
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Button
                        onClick={() => {
                          endSnooze(snooze);
                        }}
                        className='dropdown-item'
                      >
                        End snooze
                      </Button>
                    </Dropdown.Menu>
                  </DropdownWrapper>
                </td>
              </tr>
            </Fragment>
          ))
        }
      />
    </>
  );
};
